import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo" aria-label="Footer">
      <div className="site-footer__inner container">
        <div className="site-footer__brand" aria-label="The Month in Bath footer">
          <span>The Month in Bath</span>
        </div>
        <div className="site-footer__links">
          <Link to="/" className="footer__link">Home</Link>
          <Link to="/about" className="footer__link">About Us</Link>
          <a
            className="footer__link"
            href="mailto:monthinbath@gmail.com?subject=Contact%20from%20Month%20in%20Bath%20Website"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
